module.exports = __webpack_public_path__ + "static/media/bg.45ec9894.png";